module.exports = __webpack_public_path__ + "static/media/katharine.5dcc13d1.jpeg";